import React from "react";
import { statusInfo } from "../../api/ideas";
import {
    ClockIcon, CheckIcon, GearIcon, EyeIcon,
    StarIcon, XIcon, SnowIcon,
} from "./IdeasIcons";

/**
 * Цветной бейдж статуса с иконкой состояния. Иконка пульсирует для
 * «активных» статусов (voting / in_progress / testing) — это сразу даёт
 * визуальную подсказку «над этим идёт работа».
 */
const ICONS = {
    voting:      ClockIcon,
    accepted:    CheckIcon,
    in_progress: GearIcon,
    testing:     EyeIcon,
    done:        StarIcon,
    rejected:    XIcon,
    frozen:      SnowIcon,
};
const PULSE = new Set(["voting", "in_progress", "testing"]);

export default function IdeaStatusBadge({ status }) {
    const info = statusInfo(status);
    const Icon = ICONS[status] || ClockIcon;
    const pulseCls = PULSE.has(status) ? " is-pulse" : "";
    return (
        <span
            className={"idz-badge" + pulseCls}
            style={{
                color: info.color,
                background: hexToBgAlpha(info.color, 0.13),
            }}
        >
            <Icon />
            {info.label}
        </span>
    );
}

function hexToBgAlpha(hex, a) {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex);
    if (!m) return "rgba(107,114,128," + a + ")";
    const n = parseInt(m[1], 16);
    return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
}
